import { MealPlanPage } from './pages/MealPlanPage';
import { AddToShoppingListPage } from './pages/AddToShoppingListPage';  

export const mealPlanRoutes = {
  path: 'meals/plan',
  children: [{
    path: '',
    element: <MealPlanPage />,
    children: [{
      path: 'add-to-shopping-list',
      element: <AddToShoppingListPage />,
    }],    
  }]
};
